import axios, { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { IndiaDesignUserFormReqBodyEntity } from "../interface/indiaDesign.interface";
import { SignInReqEntity } from "../interface/libraryGallery.interface";
import { QualifiedTradersFormEntity, QualifiedTradersReqEntity } from "../interface/qualifiedTraders.interface";
import { toastOptObj } from "../utils/constants";
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined } from "../utils/nullCheck";

export const APIURL = process.env.REACT_APP_API_URL;
export const IndiaDesignAPIURL = process.env.REACT_APP_ENV === "prod" ? process.env.REACT_APP_API_URL : 'https://jb-glass-qa-apis.jarvistechnolabs.com'

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        let message =
            "A small error has occurred, causing an interruption of service. Please try again";

        console.log("Error\n", error);

        if (axios.isAxiosError(error) && error.code === "ERR_NETWORK") {
            message =
                "We're having trouble connecting to the network. Please try again later.";
        }

        if (error && error.response) {
            const errResp: AxiosResponse = error.response;

            if (errResp && errResp.data && !errResp.data.status) {
                message =
                    errResp.data &&
                        errResp.data.statusCode &&
                        errResp.data.statusCode === 400
                        ? errResp.data.message
                        : error.response.data.message;

                //   setTimeout(() => {
                //     if (error.response.data && error.response.data.statusCode === 440) {
                //       window.location.href = "/";
                //       localStorage.removeItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN);
                //     }

                //     if (error.response.data && error.response.data.statusCode === 503) {
                //       window.location.href = "/under-maintenance";
                //       localStorage.removeItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN);
                //     }
                //   }, 3000);
            }
        }
        console.log("message:- ", message)
        toast.error(message, { ...toastOptObj });

    }
);

export const APIGetAllAlbumsWithTheirPhotos = async (albumId: string | null, roleId: string, pageSize: number, pageNumber: number): Promise<AxiosResponse> => {
    let queryParams = "";
    queryParams = queryParams.concat(`pageSize=${pageSize}`);

    queryParams = queryParams.concat(`&pageNumber=${pageNumber + 1}`);
    if (albumId && !IsStringNullEmptyOrUndefined(albumId)) {
        queryParams = queryParams.concat(`&albumId=${albumId}`);
    }
    if (roleId && !IsStringNullEmptyOrUndefined(roleId)) {
        queryParams = queryParams.concat(`&roleId=${roleId}`);
    }

    return await axios.get(`${APIURL}/web/album/get-all-albums-with-their-photos?${queryParams}`);
};

export const APIGetAlbumsLocation = async (id: string): Promise<AxiosResponse> => {
    return await axios.get(`${APIURL}/web/album/get-location/${id}`);
};

export const APIGetSearchPhotosByTagsAndDisplayname = async (searchText: string[] | null | undefined, roleId: string, pageNumber: number, pageSize: number): Promise<AxiosResponse> => {
    let queryParams = "";

    queryParams = queryParams.concat(`pageSize=${pageSize}`);
    queryParams = queryParams.concat(`&pageNumber=${pageNumber + 1}`);

    if (searchText && !IsNullOrEmptyArray(searchText)) {
        queryParams = queryParams.concat(`&searchText=${JSON.stringify(searchText)}`);
    }
    if (roleId && !IsStringNullEmptyOrUndefined(roleId)) {
        queryParams = queryParams.concat(`&roleId=${roleId}`);
    }

    return await axios.get(`${APIURL}/web/photo/search-photos-by-tags-and-displayname?${queryParams}`);
};

export const APISignInUser = async (
    reqObj: SignInReqEntity
): Promise<AxiosResponse> => {
    return await axios.post(`${APIURL}/web/user/sign-in`, reqObj);
};

export const APIGetUserInfoFromToken = async (
    token: string
): Promise<AxiosResponse> => {
    const instance = axios.create({
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return await instance.get(`${APIURL}/web/user/fetch-user-info-from-token`);
};

export const APIGetAlbumLocation = async (
    id: string
): Promise<AxiosResponse> => {
    return await axios.get(`${APIURL}/web/album/get-location/${id}`);
};

export const APIGetVisitorArchitectInfo = async (
    uuid: string
): Promise<AxiosResponse> => {
    return await axios.get(`${IndiaDesignAPIURL}/web/campaign/get-visitor-architect-info?uuid=${uuid}`);
};

export const APIForSubmitVisitorArchitectInfo = async (
    reqBody: IndiaDesignUserFormReqBodyEntity
): Promise<AxiosResponse> => {
    return await axios.post(`${IndiaDesignAPIURL}/web/campaign/submit-event-form`, reqBody);
};

export const APIForVerifySalesPersonInvite = async (salesPersonId: string, whatsappNumber: string): Promise<AxiosResponse> => {
    return await axios.get(`${IndiaDesignAPIURL}/web/campaign/verify-sales-person-invite/${salesPersonId}/${whatsappNumber}`);
}

export const APISubmitIndiaDesignInviteForLead = async (data: any): Promise<AxiosResponse> => {
    return await axios.post(`${IndiaDesignAPIURL}/web/campaign/submit-invite-for-lead-india-design`, data);
}

export const APIDocumentVerify = async (
    reqObj: any
): Promise<AxiosResponse> => {
    return await axios.post(`${IndiaDesignAPIURL}/web/document-verify`, reqObj);
};

export const APIForSubmitQualifiedTraderDetails = async (
    reqBody: QualifiedTradersReqEntity
): Promise<AxiosResponse> => {
    return await axios.post(`${IndiaDesignAPIURL}/web/jb-connect/qualified-traders`, reqBody);
};

export const APIGetQualifiedTradersDetails = async (id: string): Promise<AxiosResponse> => {
    return await axios.get(`${IndiaDesignAPIURL}/web/jb-connect/get-qualified-trader-details/${id}`);
};


export const APIUploadQualifiedTradersShowroomPhotos = async (
    id: string,
    data: FormData
): Promise<AxiosResponse> => {
    const instance = axios.create({
        headers: {
            "content-type": "multipart/form-data",
            "Custom-Multipart-Header": "true",
        },
    });

    return await instance.post(
        `${IndiaDesignAPIURL}/app/jb-connect/upload/${id}`,
        data
    );
};

export const APIGetAlbumsDetails = async (names: string[]): Promise<AxiosResponse> => {
    const queryString = names.map(name => `name=${encodeURIComponent(name)}`).join('&');
    return await axios.get(`${APIURL}/web/album/get-album-details?${queryString}`);
};
